export default __webpack_public_path__ + "static/media/2.f4477123.svg";